import { useContext, useEffect, useMemo, useState } from "react";
import _ from "underscore";
import { callautopopulate } from "../../../services/callautopop";
import { ToastContext } from "../../../context/ToastContext";
import { dateConvert } from "../../../utils/Helper";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { encryptData } from "../../../utils/encrypt";
import CommonImage from "../../../components/CommonCompo/CommonImage/CommonImage";

export const useInventoryAssetForm = ({ onClose, editData, dropdownOpts, columnConfig, selectedAssetType, handleAssetDetails }) => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [fieldValues, setFieldValues] = useState({ asset_unique_id: "", machine_host_name: "", finance_unique_id: "", asset_type_name: null, make: null, model_number: "", serial_number: "", purchase_date: "", warranty_end_date: "", life: 0, vendor: null, purchase_price: 0, invoice_number: "", location: null, branch: null, business_unit: null, sub_business_unit: null, cpu_in_gen_ghz: null, ssid: null, os: null, lan: null, wi_fi: null, windows_key: null, status: null, insured_by: null, chargeback_to: null, monitor_charger_sr_no: "", is_discontinue: null, discontinue_by: "", remark: "", attribute_type: null, attribute_value: "", media: [], is_rental: { name: "No", val: false, label: "No" } });
    const [options, setOptions] = useState({ asset_type: [], make: [], vendor: [], branch: [], business_unit: [], sub_business_unit: [], location: [], cpu_in_gen_ghz: [], ssid: [], os: [], status: [], is_rental: [{ name: "No", val: false, label: "No" }, { name: "Yes", val: true, label: "Yes" }], attribute_type: [], all_assets: [] });
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState({ asset_unique_id: "", machine_host_name: "", finance_unique_id: "" });
    const [filteredBranchOpts, setFilteredBranchOpts] = useState([]);
    const [dynamicFields, setDynamicFields] = useState([]);
    const [draft, setDraft] = useState({ confirmation: false });
    let formFields = [
        {
            title: "Identity & Hardware",
            children: [
                {
                    title: "Asset Unique ID",
                    name: "asset_unique_id",
                    col: "12",
                    type: "text",
                    required: true,
                    disabled: editData?.asset_id || false
                },
                {
                    title: "Machine Host Name",
                    name: "machine_host_name",
                    col: "12",
                    type: "text",
                    required: true,
                    disabled: editData?.asset_id || false
                },
                {
                    title: "Asset Type",
                    name: "asset_type_name",
                    col: "12",
                    type: "select",
                    option: options?.asset_type,
                    required: true,
                    disabled: true
                },
                {
                    title: "Make",
                    name: "make",
                    col: "12",
                    type: "select",
                    option: options?.make,
                    required: true,
                },
                {
                    title: "Model Number",
                    name: "model_number",
                    col: "12",
                    type: "text",
                    required: true,
                },
                {
                    title: "Serial Number",
                    name: "serial_number",
                    col: "12",
                    type: "text",
                    required: true,
                },
                {
                    title: "Status",
                    name: "status",
                    col: "12",
                    type: "select",
                    option: options?.status,
                    required: true,
                },
            ]
        },
        {
            title: "Procurement & Finance",
            children: [
                {
                    title: "Finance Unique ID",
                    name: "finance_unique_id",
                    col: "12",
                    type: "text",
                    required: true,
                    disabled: editData?.asset_id || false
                },
                {
                    title: "Is Rented?",
                    name: "is_rental",
                    col: "12",
                    type: "select",
                    option: options?.is_rental,
                    required: true,
                },
                {
                    title: "Vendor",
                    name: "vendor",
                    col: "12",
                    type: "select",
                    option: options?.vendor,
                    required: true,
                },
                {
                    title: "Invoice No.",
                    name: "invoice_number",
                    col: "12",
                    type: "text",
                    required: true,
                },
                {
                    title: fieldValues?.is_rental?.val ? "Rental Price" : "Purchase Price",
                    name: "purchase_price",
                    col: "12",
                    type: "number",
                    required: true,
                },
                {
                    title: fieldValues?.is_rental?.val ? "Rental Date" : "Purchase Date",
                    name: "purchase_date",
                    col: "12",
                    type: "date",
                    required: true,
                },
                {
                    title: "Warranty Date",
                    name: "warranty_end_date",
                    col: "12",
                    type: "date",
                    required: true,
                },
                {
                    title: "Life (months)",
                    name: "life",
                    col: "12",
                    type: "text",
                    required: true,
                },
                // {
                //     title: "Is Discontinue",
                //     name: "is_discontinue",
                //     col: "12",
                //     type: "select",
                //     option: options?.is_rental,
                //     required: false,
                // },
                // {
                //     title: "Discontinue Date",
                //     hide: !fieldValues?.is_discontinue?.val,
                //     name: "discontinue_by",
                //     col: "12",
                //     type: "date",
                //     required: true,
                // },
            ]
        },
        {
            title: "Organization & Location",
            children: [
                {
                    title: "Location",
                    name: "location",
                    col: "12",
                    type: "select",
                    option: options?.location,
                    required: true,
                },
                {
                    title: "Branch",
                    name: "branch",
                    col: "12",
                    type: "select",
                    option: filteredBranchOpts,
                    required: true,
                },
                {
                    title: "Business Unit",
                    name: "business_unit",
                    col: "12",
                    type: "select",
                    option: options?.business_unit,
                    required: false,
                },
                {
                    title: "Sub Business Unit",
                    name: "sub_business_unit",
                    col: "12",
                    type: "select",
                    option: options?.sub_business_unit,
                    required: false,
                },
                {
                    title: "Insured By",
                    name: "insured_by",
                    col: "12",
                    type: "select",
                    option: options?.location,
                    required: false,
                },
                {
                    title: "Chargeback To",
                    name: "chargeback_to",
                    col: "12",
                    type: "select",
                    option: options?.business_unit,
                    required: false,
                },
            ]
        },
        {
            title: "Technical & Network",
            hide: dynamicFields?.length === 0,
            children: dynamicFields,
        },
        {
            title: "Remarks & Operational Notes (Optional)",
            children: [
                {
                    title: "",
                    name: "remark",
                    placeholder: "Enter detailed notes here...",
                    col: "12",
                    type: "textarea",
                    required: false,
                    child_width: 100
                }
            ]
        },
        {
            title: "Media Upload (Optional)",
            width: dynamicFields?.length === 0 ? 100 : null,
            component: (
                <div className="my-1">
                    <CommonImage type="upload" selectedImages={fieldValues?.media} setSelectedImages={(val) => { setFieldValues((prev) => ({ ...prev, media: val })) }} />
                </div>
            )
        },
    ]

    useEffect(() => {
        callautopopulate("business_units", "sub_business_units")?.then(res => {
            setOptions((prev) => ({
                ...prev,
                business_unit: _.sortBy(_.filter(res?.business_units, (bu) => bu?.business_unit), "business_unit")?.map(item => { return { ...item, label: item?.business_unit } }) || [],
                sub_business_unit: _.sortBy(_.filter(res?.sub_business_units, (sub) => sub?.sub_business_unit), "sub_business_unit")?.map(item => { return { ...item, label: item?.sub_business_unit } }) || [],
            }))

        })

        const attributes = _.sortBy(_.uniq(dropdownOpts?.asset_attributes_type, "attribute_type_id"), "attribute_type_name");

        const ssid = dropdownOpts?.ssid?.map((item) => { return { ssid_id: item?.asset_ssid, ssid_name: item?.asset_ssid_name } });
        setOptions((prev) => ({
            ...prev,
            branch: dropdownOpts?.branch?.map(item => { return { ...item, label: item?.branch_name } }),
            make: dropdownOpts?.asset_make?.map(item => { return { ...item, label: item?.asset_make_name } }),
            status: dropdownOpts?.status?.map(item => { return { ...item, label: item?.status_name } }),
            asset_type: dropdownOpts?.asset_type?.map(item => { return { ...item, label: item?.asset_type_name } }) || [],
            vendor: dropdownOpts?.vendor?.map(item => { return { ...item, label: item?.vendor_name } }) || [],
            location: _.sortBy(_.filter(dropdownOpts?.locations, (loc) => loc?.location), "location")?.map(item => { return { ...item, label: item?.location } }) || [],
            cpu_in_gen_ghz: _.sortBy(_.filter(dropdownOpts?.cpu_in_gen_ghz, item => item?.cpu_in_gen_ghz_name), "cpu_in_gen_ghz")?.map(item => { return { ...item, label: item?.cpu_in_gen_ghz_name } }) || [],
            ssid: _.sortBy(_.filter(ssid, (item) => item?.ssid_name))?.map(item => { return { ...item, label: item?.ssid_name } }) || [],
            os: _.sortBy(_.filter(dropdownOpts?.os, (item) => item?.os_name))?.map(item => { return { ...item, label: item?.os_name } }) || [],
            all_assets: dropdownOpts?.assets_details,
            attribute_type: attributes
        }))

        setFieldValues((prev) => ({ ...prev, asset_type_name: selectedAssetType ? _.findWhere(dropdownOpts?.asset_type?.map(item => { return { ...item, label: item?.asset_type_name } }), { asset_type_id: selectedAssetType?.asset_type_id }) : null }))

    }, [dropdownOpts])

    useEffect(() => {
        !_.isEmpty(editData) && handleEdit();
    }, [editData, options])

    useEffect(() => {
        if (!_.isEmpty(fieldValues?.location)) {
            const filteredBranch = _.filter(dropdownOpts?.branch, (item) => item?.location_name === fieldValues?.location?.location)?.map(item => { return { ...item, label: item?.branch_name } });
            setFilteredBranchOpts(filteredBranch);
            setFieldValues((prev) => ({ ...prev, branch: _.findWhere(filteredBranch, { branch_id: fieldValues?.branch?.branch_id }) }))
        }
    }, [fieldValues?.location?.location])

    useEffect(() => {
        handleDynamicColumns();
    }, [options])

    const handleSave = async (saveAsDraft) => {
        try {
            if (saveAsDraft) {
                setDraft((prev) => ({ ...prev, confirmation: false }));
                sessionStorage.setItem(`${selectedAssetType?.asset_type_name?.toLowerCase()?.split(" ")?.join("_")}_inventory_draft`, encryptData(fieldValues));
                onClose();
                return;
            }
            if (!fieldValues?.asset_unique_id) {
                showInfo("Info", "Please enter Asset Unique Id");
                return;
            } else if (!fieldValues?.machine_host_name) {
                showInfo("Info", "Please enter Machine Host Name");
                return;
            } else if (_.isEmpty(fieldValues?.asset_type_name)) {
                showInfo("Info", "Please select Asset Type");
                return;
            } else if (_.isEmpty(fieldValues?.make)) {
                showInfo("Info", "Please select Make");
                return;
            } else if (!fieldValues?.model_number) {
                showInfo("Info", "Please enter Model Number");
                return;
            } else if (!fieldValues?.serial_number) {
                showInfo("Info", "Please enter Serial Number");
                return;
            } else if (_.isEmpty(fieldValues?.status)) {
                showInfo("Info", "Please select Status");
                return;
            } else if (!fieldValues?.finance_unique_id) {
                showInfo("Info", "Please enter Finance Unique Id");
                return;
            } else if (_.isEmpty(fieldValues?.vendor)) {
                showInfo("Info", "Please select Vendor");
                return;
            } else if (!fieldValues?.invoice_number) {
                showInfo("Info", "Please enter Invoice Number");
                return;
            } else if (!fieldValues?.purchase_price) {
                showInfo("Info", "Please enter Purchase Price");
                return;
            } else if (!fieldValues?.purchase_date) {
                showInfo("Info", "Please select Purchase Date");
                return;
            } else if (!fieldValues?.warranty_end_date) {
                showInfo("Info", "Please select Warranty End Date");
                return;
            } else if (!fieldValues?.life) {
                showInfo("Info", "Please enter Life");
                return;
            } else if (_.isEmpty(fieldValues?.location)) {
                showInfo("Info", "Please select Location");
                return;
            } else if (_.isEmpty(fieldValues?.branch)) {
                showInfo("Info", "Please select Branch");
                return;
            } else if (error?.asset_unique_id) {
                showInfo("Info", "Please enter a different asset unique id");
                return;
            } else if (error?.machine_host_name) {
                showInfo("Info", "Please enter a different machine host name");
                return;
            } else if (error?.finance_unique_id) {
                showInfo("Info", "Please enter a different finance unique id");
                return;
            } else {
                setLoader(true);
                let tvpArray = [];
                dynamicFields?.forEach((item) => {
                    const key = item?.name;
                    const unitName = (typeof (fieldValues?.[key]) === "object" ? fieldValues?.[key]?.[`${item?.name}_name`] : (fieldValues?.[key] === true ? "Yes" : (fieldValues?.[key] === false ? "No" : fieldValues?.[key]))) || "";
                    if (unitName) {
                        tvpArray.push({
                            attribute_type_id: item?.col_id,
                            attribute_unit_id: fieldValues?.[`${key}_unit_id`] || 0,
                            attribute_unit_name: unitName,
                            is_enable_insert: typeof (fieldValues?.[key]) === "object" ? (fieldValues?.[key]?.[`${key}_id`] === 0 ? true : false) : ((options?.[key] && _.isEmpty(_.findWhere(options?.[key], { [`${key}_name`]: fieldValues?.[key] }))) ? true : false)
                        });
                    }
                });

                const mediaTvpArray = fieldValues?.media?.map((item) => {
                    const mediaData = _.filter(editData?.media, (obj) => _.isEqual(obj?.media_obj, item));
                    return {
                        "asset_unique_id": fieldValues?.asset_unique_id || "",
                        "media_file_id": mediaData?.[0]?.details?.media_file_id || 0,
                        "asset_id": !_.isEmpty(editData) ? editData?.asset_id : 0,
                        "asset_base64_string": item?.base64 || "",
                        "asset_unique_file_id": ""
                    }
                }) || [];

                editData?.media?.forEach((item) => {
                    if (_.isEmpty(_.findWhere(mediaTvpArray, { asset_id: item?.details?.asset_id }))) {
                        mediaTvpArray.push({
                            "asset_unique_id": "",
                            "media_file_id": 0,
                            "asset_id": item?.details?.asset_id || 0,
                            "asset_base64_string": "",
                            "asset_unique_file_id": ""
                        })
                    }
                })

                const payload = {
                    "asset_id": !_.isEmpty(editData) ? editData?.asset_id : 0,
                    "asset_unique_id": fieldValues?.asset_unique_id || "",
                    "machine_host_name": fieldValues?.machine_host_name || "",
                    "finance_unique_id": fieldValues?.finance_unique_id || "",
                    "asset_type_id": fieldValues?.asset_type_name?.asset_type_id || 0,
                    "asset_make_id": fieldValues?.make?.asset_make_id || 0,
                    "model_number": fieldValues?.model_number || "",
                    "serial_number": fieldValues?.serial_number || "",
                    "purchase_date": fieldValues?.purchase_date ? dateConvert(fieldValues?.purchase_date, "iso-string") : "",
                    "warranty_end_date": fieldValues?.warranty_end_date ? dateConvert(fieldValues?.warranty_end_date, "iso-string") : "",
                    "life_in_months": fieldValues?.life || 0,
                    "vendor_id": fieldValues?.vendor?.vendor_id || 0,
                    "invoice_number": fieldValues?.invoice_number || "",
                    "purchase_price": fieldValues?.purchase_price ? parseFloat(fieldValues?.purchase_price) : 0,
                    "branch_id": fieldValues?.branch?.branch_id || 0,
                    "status_id": fieldValues?.status?.status_id || 0,
                    "is_discontinue": fieldValues?.is_discontinue?.val || false,
                    "discontinued_date": fieldValues?.discontinue_by ? dateConvert(fieldValues?.discontinue_by, "iso-string") : "",
                    "remark": fieldValues?.remark || "",
                    "attribute_type_unit_mapping": tvpArray,
                    "assets_original_media": mediaTvpArray,
                    "business_unit": fieldValues?.business_unit?.business_unit || "",
                    "sub_business_unit": fieldValues?.sub_business_unit?.sub_business_unit || "",
                    "insured_by": fieldValues?.insured_by?.location || "",
                    "chargeback_to": fieldValues?.chargeback_to?.business_unit || "",
                    "is_rental": fieldValues?.is_rental?.val
                }
                const res = await services.getInvokeRemote("POST", Urls("UPSERTASSETDETAILS"), payload);
                if (res) {
                    showSuccess("Success", res?.body?.message);
                    setLoader(false);
                    handleAssetDetails();
                    onClose();
                    if (fieldValues?.is_draft) sessionStorage.removeItem(`${selectedAssetType?.asset_type_name?.toLowerCase()?.split(" ")?.join("_")}_inventory_draft`);
                }
            }
        } catch (error) {
            console.error("Error: ", error);
            showError("Error", error?.response?.data?.errorMessage || "Asset details not saved!");
            setLoader(false);
        }
    }

    const handleEdit = () => {
        let editedFields = {
            ...editData,
            asset_type_name: selectedAssetType ? _.findWhere(options?.asset_type, { asset_type_id: selectedAssetType?.asset_type_id }) : (editData?.asset_type_id ? _.findWhere(options?.asset_type, { asset_type_id: editData?.asset_type_id }) : (typeof (editData?.asset_type_name) === "object" ? editData?.asset_type_name : {})),
            make: editData?.asset_make_id ? _.findWhere(options?.make, { asset_make_id: editData?.asset_make_id }) : (typeof (editData?.make) === "object" ? editData?.make : {}),
            purchase_date: editData?.purchase_date ? new Date(editData?.purchase_date) : null,
            warranty_end_date: editData?.warranty_end_date ? new Date(editData?.warranty_end_date) : null,
            life: editData?.life_in_months,
            vendor: editData?.vendor_id ? _.findWhere(options?.vendor, { vendor_id: editData?.vendor_id }) : (typeof (editData?.vendor) === "object" ? editData?.vendor : {}),
            branch: editData?.branch_id ? _.findWhere(options?.branch, { branch_id: editData?.branch_id }) : (typeof (editData?.branch) === "object" ? editData?.branch : {}),
            location: editData?.location_name ? _.findWhere(options?.location, { location: editData?.location_name }) : (typeof (editData?.location) === "object" ? editData?.location : {}),
            status: editData?.status_id ? _.findWhere(options?.status, { status_id: editData?.status_id }) : (typeof (editData?.status) === "object" ? editData?.status : {}),
            is_discontinue: { name: !editData?.is_discontinue ? "No" : "Yes", val: editData?.is_discontinue },
            discontinue_by: editData?.discontinued_date ? new Date(editData?.discontinued_date) : null,
            attribute_type: null,
            attribute_value: "",
            media: (editData?.media?.[0]?.media_obj ? _.pluck(editData?.media, "media_obj") : editData?.media?.map(item => { return { base64: item?.base64FullString || item?.base64 || "", file: item?.base64FullString || item?.base64 || "" } })) || [],
            business_unit: editData?.business_units ? _.findWhere(options?.business_unit, { business_unit: editData?.business_units }) : (typeof (editData?.business_unit) === "object" ? editData?.business_unit : {}),
            sub_business_unit: editData?.sub_business_units ? _.findWhere(options?.sub_business_unit, { sub_business_unit: editData?.sub_business_units }) : (typeof (editData?.sub_business_unit) === "object" ? editData?.sub_business_unit : {}),
            insured_by: typeof (editData?.insured_by) === "object" ? editData?.insured_by : _.findWhere(options?.location, { location: editData?.insured_by }),
            chargeback_to: typeof (editData?.chargeback_to) === "object" ? editData?.chargeback_to : _.findWhere(options?.business_unit, { business_unit: editData?.chargeback_to }),
            is_rental: typeof (editData?.is_rental) === "object" ? editData?.is_rental : _.findWhere(options?.is_rental, { val: editData?.is_rental || false }),
        }

        // pre-fill values of dynamic fields
        const assetAttributes = _.findWhere(columnConfig, { asset_type_id: selectedAssetType?.asset_type_id })?.saved_columns;
        let attributeData = {};
        const autocompleteKeys = ["cpu_in_gen_ghz", "ssid", "os"];

        assetAttributes?.forEach(item => {
            attributeData[item?.attribute_type_key] = null;
            if (editData?.attributes) {
                const findData = _.findWhere(editData?.attributes, { attribute_type_id: item?.attribute_type_id });
                if (!_.isEmpty(findData)) {
                    let value = findData?.attribute_unit_name;
                    if (autocompleteKeys?.includes(item?.attribute_type_key)) {
                        const filterData = _.findWhere(options?.[item?.attribute_type_key], { [`${item?.attribute_type_key}_name`]: value });
                        if (!_.isEmpty(filterData)) {
                            attributeData[item?.attribute_type_key] = filterData;
                            attributeData[`${item?.attribute_type_key}_unit_id`] = findData?.attribute_unit_id;
                        }
                    } else {
                        attributeData[item?.attribute_type_key] = value?.toLowerCase()?.trim() === "yes" ? true : (value?.toLowerCase()?.trim() === "no" ? false : value);
                        attributeData[`${item?.attribute_type_key}_unit_id`] = findData?.attribute_unit_id;
                    }
                }
            } else {
                // set dynamic fields value when load from draft
                attributeData[item?.attribute_type_key] = editData?.[item?.attribute_type_key];
            }
        })
        setFieldValues((prev) => ({ ...prev, ...editedFields, ...attributeData }));
    }

    const handleReset = () => {
        setFieldValues({ asset_unique_id: "", machine_host_name: "", finance_unique_id: "", asset_type_name: null, make: null, model_number: "", serial_number: "", purchase_date: "", warranty_end_date: "", life: 0, vendor: null, purchase_price: 0, invoice_number: "", branch: null, location: null, business_unit: null, sub_business_unit: null, cpu_in_gen_ghz: null, ssid: null, os: null, lan: null, wi_fi: null, windows_key: null, status: null, insured_by: null, chargeback_to: null, monitor_charger_sr_no: "", is_discontinue: null, discontinue_by: "", remark: "", attribute_type: null, attribute_value: "", media: [], is_rental: _.findWhere(options?.is_rental, { val: false }) });
    }

    const validateUniqueId = (key, validateValue) => {
        if (!editData?.asset_id) {
            const allSavedIds = _.filter(_.pluck(options?.all_assets, key), (item) => item)?.map((item) => { return item?.toLowerCase() })
            if (allSavedIds?.includes((validateValue ? validateValue : fieldValues?.[key])?.toLowerCase())) {
                setError((prev) => ({ ...prev, [key]: `This ${key?.split("_")?.join(" ")} already exists` }));
                return true;
            } else {
                setError((prev) => ({ ...prev, [key]: "" }));
                return false;
            }
        }
    }

    const handleChange = (obj, e, is_edit) => {
        if (obj?.type === "autocomplete") {
            const data = _.findWhere(options?.[obj?.name], { [`${obj?.name}_name`]: e.target?.value });
            if (!_.isEmpty(data)) {
                setFieldValues((prev) => ({ ...prev, [obj?.name]: data }));
            } else {
                const newObj = { [`${obj?.name}_id`]: 0, [`${obj?.name}_name`]: e?.target?.value, label: e?.target?.value };
                setFieldValues((prev) => ({ ...prev, [obj?.name]: newObj }));
            }
            // handleAutocompleteValueChange(obj?.name, e.target.value, is_edit ? true : false);
        } else {
            setFieldValues((prev) => ({ ...prev, [obj?.name]: obj?.type === "checkbox" ? e.target?.checked : e.target?.value }));
        }
    }

    const handleDynamicColumns = () => {
        // set dynamic tech fields
        let attri = [];
        const assetAttributes = _.findWhere(columnConfig, { asset_type_id: selectedAssetType?.asset_type_id })?.saved_columns;
        assetAttributes?.forEach(item => {
            let obj = {
                col_id: item?.attribute_type_id,
                title: item?.attribute_type_name,
                name: item?.attribute_type_key,
                col: "12",
                type: item?.column_type || "",
                required: false,
            };
            if (item?.column_type === "autocomplete") {
                obj.name = item?.attribute_type_key;
                obj["option"] = options?.[item?.attribute_type_key];
            } else if (item?.column_type === "boolean") {
                obj.type = "checkbox"
            }
            attri.push(obj);
        })
        setDynamicFields(attri);
    }

    return useMemo(() => ({
        fieldValues, handleReset, handleSave, loader, validateUniqueId, error, formFields, handleChange, draft, setDraft
    }), [fieldValues, handleReset, handleSave, loader, validateUniqueId, error, formFields, handleChange, draft, setDraft])
}